import { defineStore } from 'pinia'
import type { FlightArea } from '@/types/flightArea'
import { fetchFlightAreas } from '@/api/flightAreasApi'

export const useFlightAreaStore = defineStore('flightArea', {
  state: () => ({
    selectedFlightAreaId: null as number | null,
    flightAreas: [] as FlightArea[],
  }),

  getters: {
    hasFlightArea(state): boolean {
      return state.flightAreas.length > 0
    },
  },

  actions: {
    /**
     * APIからフライトエリア一覧を取得
     */
    async fetchFlightAreas() {
      const flightAreas = await fetchFlightAreas()
      this.flightAreas = flightAreas
      sessionStorage.setItem('flightAreas', JSON.stringify(this.flightAreas))
    },

    /**
     * ページロード時に SessionStorage から復元
     */
    loadFromSession() {
      const areas = sessionStorage.getItem('flightAreas')
      if (areas) {
        this.flightAreas = JSON.parse(areas) as FlightArea[]
      }

      const id = sessionStorage.getItem('selectedFlightAreaId')
      if (id) {
        this.selectedFlightAreaId = Number(id)
      }
    },

    /**
     * 選択中のフライトエリアIDを保存
     */
    setSelectedFlightArea(id: number) {
      this.selectedFlightAreaId = id
      sessionStorage.setItem('selectedFlightAreaId', String(id))
    },

    /**
     * ログイン時に呼び出す
     *
     * ・Piniaのstateを初期化
     * ・sessionStorageに保存されているエリア情報を削除
     *
     * 前ユーザの情報が次ユーザに引き継がれるのを防ぐ
     */
    clearStore() {
      this.$reset()
      sessionStorage.removeItem('flightAreas')
      sessionStorage.removeItem('selectedFlightAreaId')
    },
  },
})
